<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap>
      <v-flex md12>
        <app-table
          ref='table'
          :api-getlist="getList"
          :config="config" />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import config from './config_index.js'
import { getReturnedList } from '@/api/returned'
import { mapState } from 'vuex'

export default {
  data () {
    return {
      config,
    }
  },
  computed: mapState('app', ['protocol']),
  watch: {
    protocol () {
      this.$refs.table.getData(true)
    }
  },
  methods: {
    getList (entity, filters, pagination) {
      if (this.protocol.id !== -1) {
        filters.protocol_id = this.protocol.id
      }
      return getReturnedList('returned', filters, pagination)
    }
  }
}
</script>
